import type Owner from '@ember/owner';

import { BillingFeature } from 'webapp/enums/enums';

import type { NoResultsBaseArgs } from 'webapp/components/no-results/base';
import NoResultsBaseComponent from 'webapp/components/no-results/base';

export default class NoResultsGoalsComponent extends NoResultsBaseComponent<NoResultsBaseArgs> {
	constructor(owner: Owner, args: NoResultsBaseArgs) {
		super(owner, args);

		this.titleText = 'Set goals and make sure you hit them';
		this.descText =
			'Set ambitious goals and receive real-time alerts to help you stay on track.';

		this.readMoreUrl = 'https://help.databox.com/create-a-goal';

		this.trialFeature = BillingFeature.GOALS;
		this.topImageLightUrl = '/images/placeholders/goals.svg';
		this.topImageDarkUrl = '/images/placeholders/dark/goals.svg';

		this.imageLightUrl = '/images/placeholders/placeholder-goals.svg';
		this.imageHeight = 445;

		this.trackingOrigin = 'goals';
	}

	override get mustUpgrade() {
		return !this.billingService.checkIfCan(BillingFeature.GOALS);
	}

	override get createButtonText() {
		return 'New goal';
	}
}
